import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import classnames from 'classnames';

const RowGrid = props => {
  const { children, className, isOnlyMobile } = props;
  let centerXYclass = 'center-xy';
  if (isOnlyMobile) {
    centerXYclass = 't-center-xy';
  }
  return (
    <Row {...props} className={classnames(className, centerXYclass)}>
      {children}
    </Row>
  );
};

export default RowGrid;
